__turbopack_context__.v({
  "root": "ring-client-module__yWYHfW__root",
});
